import React from 'react'
import { FormGroup, FormText, Input, Label } from 'reactstrap'
import PropTypes from 'prop-types'

const AFFILIATE_NAMES = {
  STORE_STC: {
    label : 'Store STC',
    value : 'store_stc'
  },
  CC: {
    label : 'Chat Commerce',
    value : 'chat_commerce'
  },
  BAZAAR: {
    label : 'Bazaar',
    value : 'bazaar'
  }
}

const propTypes = {
  selectedAffiliateName : PropTypes.func,
  onChangeAffiliateName : PropTypes.func
}

const defaultProps = {
  selectedAffiliateName : () => {},
  onChangeAffiliateName : () => {}
}

const CustomerCheckoutAffiliateNameField = ({
  selectedAffiliateName,
  onChangeAffiliateName
}) => (
  <FormGroup>
    <Label
      for={ 'affiliate_name' }
      className='text-gray-light text-capitalize'
    >
      <strong>{ 'Affiliate Name' }</strong>
    </Label>
    <Input
      type='select'
      name='affiliate_name'
      value={ selectedAffiliateName }
      onChange={ onChangeAffiliateName }
    >
      <option>Choose one</option>
      {
        Object.keys(AFFILIATE_NAMES).map((key) => {
          const label = AFFILIATE_NAMES[key].label
          const value = AFFILIATE_NAMES[key].value
          return (
            <option
              key={ `affiliate-name-option-${value}` }
              value={ value }
            >
              { label }
            </option>
          )
        })
      }
    </Input>
    <FormText>
      <ul>
        <li>
          <strong>{ 'Chat Commerce: ' }</strong>
          { 'Order Created by requesting to Customer Service (chat commerce)' }
        </li>
        <li>
          <strong>{ 'STC: ' }</strong>
          { 'Order purchased at offline store in STC' }
        </li>
        <li>
          <strong>{ 'Bazaar: ' }</strong>
          { 'Order purchased at bazaar' }
        </li>
      </ul>
    </FormText>
  </FormGroup>
)

CustomerCheckoutAffiliateNameField.propTypes    = propTypes
CustomerCheckoutAffiliateNameField.defaultProps = defaultProps

export default CustomerCheckoutAffiliateNameField
